<template>
  <div>
    <SyariahIndexMobile
      v-if="isMobile"
      :other-links="$options.otherLinks"
      :page-description="$options.pageDescription"
      :base-url="$options.baseUrl"
      :content-data="$options.contentData"
    />
    <SyariahIndexDesktop
      v-else
      :other-links="$options.otherLinks"
      :page-description="$options.pageDescription"
      :base-url="$options.baseUrl"
      :content-data="$options.contentData"
      :breadcrumb-links="$options.breadcrumbLinks"
    />
  </div>
</template>

<script>
import {
  getSyariahObject,
  generateOtherLinks,
  generateBreadcrumbLinks,
  seoMapperConstant as CONSTANT,
} from 'shared/helpers/seoMap';
import isMobile from 'shared/mixins/isMobile';
import SyariahIndexMobile from '../../components/mobile/syariah/SyariahIndex';
import SyariahIndexDesktop from '../../components/desktop/syariah/SyariahIndex';

const mutualFundSyariahObject = getSyariahObject();

export default {
  name: 'SyariahIndexPage',
  metaInfo() {
    return {
      title: mutualFundSyariahObject.meta_title,
      meta: [
        { name: 'description', content: mutualFundSyariahObject.meta_desc },
        { name: 'keyword', content: mutualFundSyariahObject.meta_keyword },
      ],
    };
  },
  components: {
    SyariahIndexMobile,
    SyariahIndexDesktop,
  },
  mixins: [isMobile],
  otherLinks: generateOtherLinks(CONSTANT.SYARIAH_KEY),
  pageDescription: mutualFundSyariahObject.page_desc,
  baseUrl: mutualFundSyariahObject.link_url,
  contentData: mutualFundSyariahObject.data,
  breadcrumbLinks: generateBreadcrumbLinks(CONSTANT.SYARIAH_KEY),
};
</script>
